import { gql } from '@apollo/client'

export const CREATE_FLAG_REASON_OPTION = gql`
  mutation CreateFlagReasonOption($input: CreateFlagReasonOptionInput!) {
    createFlagReasonOption(input: $input) {
      option {
        id
        type
        reason
      }
    }
  }
`
